import CheckboxSelectAll from "stimulus-checkbox-select-all"

// Bulk-Aktionen in der Bewerberliste: Mehrfachauswahl per Checkbox, dann
// "In Pool verschieben" oder "Ausgewählte löschen". Die Aktions-Leiste blendet
// sich ein, sobald mindestens ein Bewerber ausgewählt ist, zeigt einen
// Auswahl-Zähler und bestätigt das Löschen inline (statt per nativem Popup).
export default class extends CheckboxSelectAll {

    static targets = ["pool", "modal", "label", "actionsPane", "confirmPane", "confirmLabel"]

    connect() {
        super.connect()
        this.refresh()
    }

    // Wird bei jeder Checkbox-Änderung aufgerufen (change->applicants-bulk#toggle).
    toggle() {
        this.refresh()
    }

    refresh() {
        const count = this.checked.length
        if (this.hasLabelTarget) this.labelTarget.textContent = `${count} ausgewählt`

        if (count > 0) {
            this.showActions()
            this.modalTarget.classList.remove("hidden")
        } else {
            this.modalTarget.classList.add("hidden")
            this.showActions()
        }
    }

    // "Alle auswählen" / "Alle abwählen" im Tabellenkopf: setzt alle Zeilen-
    // Checkboxen auf den Zustand der Kopf-Checkbox und aktualisiert Leiste +
    // Zähler. Nötig, weil die select-all-Library beim Umschalten nur ein
    // `input`-Event feuert (kein `change`), unsere Zeilen-Hooks aber auf
    // `change` hören – ohne das hier bliebe die Leiste bei "Alle auswählen" leer.
    selectAll(event) {
        const checked = event && event.target ? event.target.checked : true
        this.checkboxTargets.forEach((checkbox) => { checkbox.checked = checked })
        this.refresh()
    }

    // Auswahl komplett aufheben (Button "Auswahl aufheben").
    clear(event) {
        if (event) event.preventDefault()
        this.checkboxTargets.forEach((checkbox) => { checkbox.checked = false })
        const selectAll = this.element.querySelector('[data-checkbox-select-all-target="checkboxAll"]')
        if (selectAll) selectAll.checked = false
        this.refresh()
    }

    moveToPool(event) {
        event.preventDefault()
        if (this.poolTarget.value === "") return
        this.submit("/backend/applicants/bulk_move_to_pool", "PUT", { pool_id: this.poolTarget.value })
    }

    // Schritt 1: Inline-Bestätigung einblenden (kein natives confirm()).
    deleteSelected(event) {
        event.preventDefault()
        const count = this.checked.length
        if (count === 0) return
        if (this.hasConfirmLabelTarget) {
            this.confirmLabelTarget.textContent =
                `${count} Bewerber endgültig löschen? Das kann nicht rückgängig gemacht werden.`
        }
        if (this.hasActionsPaneTarget) this.actionsPaneTarget.classList.add("hidden")
        if (this.hasConfirmPaneTarget) this.confirmPaneTarget.classList.remove("hidden")
    }

    cancelDelete(event) {
        if (event) event.preventDefault()
        this.showActions()
    }

    // Schritt 2: tatsächlich löschen.
    confirmDelete(event) {
        event.preventDefault()
        if (this.checked.length === 0) { this.showActions(); return }
        this.submit("/backend/applicants/bulk_delete", "DELETE")
    }

    showActions() {
        if (this.hasConfirmPaneTarget) this.confirmPaneTarget.classList.add("hidden")
        if (this.hasActionsPaneTarget) this.actionsPaneTarget.classList.remove("hidden")
    }

    submit(url, method, extraParams = {}) {
        const data = new FormData()
        this.checked.forEach((checkbox) => data.append("applicant_ids[]", checkbox.value))
        Object.entries(extraParams).forEach(([key, value]) => data.append(key, value))

        const token = document.querySelector('meta[name="csrf-token"]').content

        fetch(url, {
            method: method,
            headers: { "X-CSRF-Token": token },
            body: data
        }).then((response) => {
            if (response.redirected) {
                window.location.href = response.url
            } else {
                // Erfolg oder Fehler: Liste neu laden statt still zu scheitern.
                window.location.reload()
            }
        })
    }

}
